import React, { useEffect, useRef } from 'react';

import MetisMenu from '@metismenu/react';
import useTranslation from 'hooks/useTranslation';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
// MetisMenu
import { NavLink, withRouter } from 'react-router-dom';
// //Import Scrollbar
import SimpleBar from 'simplebar-react';

import { isUserBoughtProjectSelector } from 'store/auth/profile/selectors';
import { fetchTickets } from 'store/tickets/actions';
import { getUnreadCount } from 'store/notifications/actions';

import Icon from '../Icon';
import SidebarProjectsCategories from './SidebarProjectsCategories';
import './metisMenu.scss';

const SidebarContent = (props) => {
  const { access, dispatch } = props;
  const ref = useRef(null);
  const isDisplayInvestorFeatures = useSelector(isUserBoughtProjectSelector);
  const hasUnreadMessages = useSelector((state) => state.Tickets?.hasUnreadMessages || false);
  const unreadCount = useSelector((state) => state.Notifications?.unreadCount || 0);
  const t = useTranslation();
  const refSidebar = useRef();
  const refMenu = useRef();
  const pathName = props.location.pathname;

  useEffect(() => {
    const body = document.body;
    body.classList.toggle('sidebar-enable');

    const items = refMenu.current.el.getElementsByTagName('a');
    for (let i = 0; i < items.length; ++i) {
      const item = items[i];
      item.classList.remove('active');
      const parent = item.parentElement;
      if (parent) {
        parent.classList.remove('mm-active');
        const parent2El = parent.childNodes[1];
        if (parent2El) {
          parent2El.classList.remove('mm-show');
        }
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.remove('mm-show');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('mm-active');
            parent3.childNodes[0].classList.remove('mm-active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove('mm-show');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('mm-show');
                parent5.childNodes[0].classList.remove('mm-active');
              }
            }
          }
        }
      }
    }

    let matchingMenuItem = null;
    for (let i = 0; i < items.length; ++i) {
      const item = items[i];
      if (item.classList.contains('li__first_dropdown') && pathName.indexOf('projects') === -1) {
        continue;
      }
      if (item.classList.contains('li__sidebar') && pathName.indexOf('help') !== -1) {
        continue;
      }
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [pathName]);

  useEffect(() => {
    if (!pathName.includes('/support')) {
      const params = {
        filter_state: ['new', 'open', 'pending reminder', 'pending close'],
        take: 25,
        skip: 0,
      };

      dispatch(fetchTickets(params));

      const interval = setInterval(() => {
        dispatch(fetchTickets(params));
      }, 15000);

      return () => clearInterval(interval);
    }
  }, [dispatch, pathName]);

  useEffect(() => {
    dispatch(getUnreadCount());
    const interval = setInterval(() => {
      dispatch(getUnreadCount());
    }, 30000);
    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    refSidebar.current.recalculate();
  });

  useEffect(() => {
    const handleSidebarClick = (event) => {
      const target = event.target.closest('a');
      if (target) {
        const currentPath = props.location.pathname;
        const targetPath = target.pathname;

        if (currentPath === targetPath) {
          document.body.classList.remove('sidebar-enable');
        }
      }
    };

    const sidebarMenu = refMenu.current?.el;
    if (sidebarMenu) {
      sidebarMenu.addEventListener('click', handleSidebarClick);
    }

    return () => {
      if (sidebarMenu) {
        sidebarMenu.removeEventListener('click', handleSidebarClick);
      }
    };
  }, [props.location.pathname]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add('active');
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== 'side-menu') {
      parent2El.classList.add('mm-show');
    }

    if (parent) {
      parent.classList.add('mm-active');
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add('mm-show'); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add('mm-active'); // li
          parent3.childNodes[0].classList.add('mm-active'); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add('mm-show'); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add('mm-show'); // li
              parent5.childNodes[0].classList.add('mm-active'); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  return (
    <React.Fragment>
      <SimpleBar className="" ref={refSidebar}>
        <div id="sidebar-menu" style={{ position: 'fixed' }}>
          <MetisMenu toggle={false} ref={refMenu}>
            <li key="dashboard">
              <NavLink to="/dashboard" className="sidebar-navlink">
                <Icon name="dashboard" size={20} />
                <span>{t('sidebar_dashboard_label')}</span>
              </NavLink>
            </li>

            <li className="menu-title" key="finance">
              {t('sidebar_finance_label')}
            </li>
            {isDisplayInvestorFeatures && (
              <>
                <li key="investments">
                  <NavLink to="/investments" className="sidebar-navlink">
                    <Icon name="investments" size={20} />
                    <span>{t('sidebar_investments_label')}</span>
                  </NavLink>
                </li>
                <li key="accruals">
                  <NavLink to="/accruals" className="sidebar-navlink">
                    <Icon name="accruals" size={20} />
                    <span>{t('sidebar_accruals_label')}</span>
                  </NavLink>
                </li>
              </>
            )}

            <li className="menu-title" key="account">
              {t('sidebar_account_label')}
            </li>
            <li key="notifications">
              <NavLink to="/notifications" className="sidebar-navlink">
                <Icon name="notification" size={20} />
                <span className="sidebar-menu-label">
                  {t('sidebar_notification_label')}
                  {unreadCount > 0 && (
                    <span className="notif-badge">
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  )}
                </span>
              </NavLink>
            </li>
            <li key="profile">
              <NavLink to="/profile" className="sidebar-navlink">
                <Icon name="profile" size={20} />
                <span>{t('common_profile')}</span>
              </NavLink>
            </li>
            {/*TODO Temporary hidden*/}
            {/*{access && access.length !== 0 && (*/}
            {/*  <li key="admin">*/}
            {/*    <Link className="sidebar-navlink has-arrow li__sidebar" to={'/admins'}>*/}
            {/*      <Icon name="admin" size={20} />*/}
            {/*      <span>{t('sidebar_admin_panel_label')}</span>*/}
            {/*    </Link>*/}
            {/*    <ul className="sub-menu">*/}
            {/*      {access.includes('metrics') && (*/}
            {/*        <li className="d-flex">*/}
            {/*          <NavLink to={'/admin/metrics'}>{t('sidebar_metrics_label')}</NavLink>*/}
            {/*        </li>*/}
            {/*      )}*/}
            {/*    </ul>*/}
            {/*  </li>*/}
            {/*)}*/}
            <li>
              <NavLink to="/support" className="sidebar-navlink li__sidebar">
                <Icon name="support" size={20} />
                <span className="support-link-sidebar">
                  {t('common_support_label')}
                  {hasUnreadMessages && <span className="unread-indicator" />}
                </span>
              </NavLink>
            </li>
          </MetisMenu>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  access: PropTypes.any,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  access: state.Profile.user.role?.access || [],
});

export default connect(mapStateToProps)(withRouter(SidebarContent));
